import { render } from "./Step_five.vue?vue&type=template&id=6167999a"
import script from "./Step_five.vue?vue&type=script&lang=js"
export * from "./Step_five.vue?vue&type=script&lang=js"

import "./Step_five.vue?vue&type=style&index=0&id=6167999a&lang=less"
script.render = render

export default script